import UserDataForm from "JS/classes/myaccount/UserDataForm";

(() => {
    const userDataForm = document.querySelector('#user-data-form');
    const userPasswordForm = document.querySelector('#user-password-form');
    new UserDataForm(userDataForm);
    new UserDataForm(userPasswordForm);
})();
